<template>
  <div id="topHeader">
    <!-- 头部 -->
    <div class="header">
      <template>
        <div class="go-back" v-if="goBack" @click="$router.back(-1)"><img src="../images/frame_back-app@2x.png" alt="">{{headTitle?headTitle:$t($route.meta.title)}}</div>
        <div class="logo-cont" v-else @click="reload()"><img src="../images/home-LOGO-app@2x.png" alt=""></div>
      </template>
      <div class="btn-cont">
        <!-- <div class="lang" @click="showModal(['searchModal','menuModal'],'langModal')"> -->
        <div class="lang" style="line-height:0.5625rem;">
          <div :class="['lang-icon',langModal?'lang-checked':'']">
            <img src="../images/new/fanyi.png"/>
          </div>
        </div>
        <div class="search" @click="showModal(['langModal','menuModal'],'searchModal')">
          <div :class="['search-icon',searchModal?'search-checked':'']"></div>
        </div>
        <div class="menu" @click="showModal(['langModal','searchModal'],'menuModal')">
          <div :class="['menu-icon',menuModal?'menu-checked':'']"></div>
        </div>
      </div>
    </div>
    <!-- 模态框 -->
    <transition-group name="modal-fade">
      <div class="modal" v-if="langModal" @touchmove.prevent key="lang">
        <div class="lang-modal">
          <p @click="changeLanguage('zh')">简体中文</p>
          <p @click="changeLanguage('en')">English</p>
          <p @click="changeLanguage('tibet')"><img src="../images/lang-z-app@2x.png" alt=""></p>
        </div>
      </div>
      <div class="modal" v-if="searchModal" @touchmove.prevent key="search">
        <div class="search-modal">
          <div class="search-left">
            <span class="search-pic"></span>
            <input type="text" :placeholder="$t('search.search_text')" autocomplete="off" v-model="searchKeyWords" autofocus>
          </div>
          <span class="search-btn" @click="toSearch()">{{$t("search.search_btn")}}</span>
        </div>
      </div>
      <div class="modal" v-if="menuModal" key="menu">
        <div class="menu-modal">
          <ul class="sidebar-menu">
            <li :class="[currentUrl === item.menuUrl ? 'active':'']" v-for="(item,index) in menulist" :key="index">
              <!-- 无子项 -->
              <template v-if="!item.menuSubLink">
                <a href="javascript:;" @click="toTarget(item.menuUrl,true)">
                  <!-- <i :class="['fzicon',item.menuIcon]"></i> -->
                  <span>{{item.menuName}}</span>
                </a>
              </template>
              <!-- 有子项 -->
              <template v-else>
                <a href="javascript:;" :class="[(item.menuName === toggleName) || item.defaultActive? config.icon_expand: config.icon_collapse]" @click="isToggle(item.menuName,item.defaultActive)">
                  <!-- <i :class="['fzicon',item.menuIcon]"></i> -->
                  <span>{{item.menuName}}</span>
                  <i class="trangle"></i>
                </a>
                <transition name="sliderToggle" mode="out-in">
                  <ul class="tree-menu" v-show="item.menuName === toggleName || item.defaultActive">
                    <li v-if="!subitem.menuHide" v-for="(subitem,subindex) in item.menuSubLink" :key="subindex" :class="currentUrl === subitem.menuUrl ? 'active':''">
                      <a href="javascript:;" @click="toTarget(subitem.menuUrl,false)">
                        <!-- <i :class="subitem.menuIcon"></i> -->
                        <span>{{subitem.menuName}}</span>
                      </a>
                    </li>
                  </ul>
                </transition>
              </template>
            </li>
          </ul>
        </div>
      </div>
    </transition-group>
  </div>
</template>

<script>
export default {
  name: "app",
  props: {
    goBack: {
      type: Boolean,
      default: () => false
    },
    headTitle: {
      type: String,
      default: ""
    }
  },
  inject: ["reload"],
  data() {
    return {
      langModal: false,
      searchModal: false,
      menuModal: false,
      currentModal: "",
      searchKeyWords: "",
      menulist: [
        {
          menuName: this.$t("menu.dashboard"),
          menuIcon: "",
          menuUrl: "/Index"
        },
        {
          menuName: this.$t("menu.abstract"),
          menuIcon: "",
          menuUrl: "",
          menuSubLink: [
            {
              menuName: this.$t("menu.ab_history"),
              menuUrl: "/history"
            },
            {
              menuName: this.$t("menu.ab_structuring"),
              menuUrl: "/organization"
            },

            {
              menuName: this.$t("menu.ab_words"),
              menuUrl: "/speech"
            },
            {
              menuName: this.$t("menu.ab_events"),
              menuUrl: "/bigEvent"
            },
            {
              menuName: this.$t("menu.ab_expansion_project"),
              menuUrl: "/extendPro"
            }
          ]
        },
        {
          menuName: this.$t("menu.exhibition"),
          menuIcon: "",
          menuUrl: "",
          menuSubLink: [
            {
              menuName: this.$t("menu.ex_zhaunti"),
              menuUrl: "/exhibitHome?t=special"
            },
            {
              menuName: this.$t("menu.ex_huimou"),
              menuUrl: "/exhibitHome?t=review"
            },
            {
              menuName: this.$t("menu.ex_allsence"),
              menuUrl: "/exhibitHome?t=allsence"
            }
          ]
        },
        {
          menuName: this.$t("menu.zangpinDisplay"),
          menuIcon: "",
          menuUrl: "",
          menuSubLink: [
            {
              menuName: this.$t("menu.zp_treasures"),
              menuUrl: "/treasures"
            },
            {
              menuName: this.$t("menu.zp_fast_look"),
              menuUrl: "/fastLook"
            },
            {
              menuName: this.$t("menu.zp_collection_donation"),
              menuUrl: "/collection"
            }
          ]
        },
        {
          menuName: this.$t("menu.cultural"),
          menuIcon: "",
          menuUrl: "",
          menuSubLink: [
            {
              menuName: this.$t("menu.cul_beautity"),
              menuUrl: "/culturalHome?t=beautity"
            },
            {
              menuName: this.$t("menu.cultural"),
              menuUrl: "/culturalHome?t=product"
            },
            {
              menuName: this.$t("menu.cul_news"),
              menuUrl: "/culturalHome?t=news"
            }
          ]
        },
        {
          menuName: this.$t("menu.educationActivity"),
          menuIcon: "",
          menuUrl: "",
          menuSubLink: [
            {
              menuName: this.$t("menu.edu_latest_activities"),
              menuUrl: "/educationHome?t=ac_latest"
            },
            {
              menuName: this.$t("menu.edu_special_activities"),
              menuUrl: "/educationHome?t=ac_special"
            },
            {
              menuName: this.$t("menu.edu_review_activities"),
              menuUrl: "/educationHome?t=ac_review"
            },
            {
              menuName: this.$t("menu.edu_children"),
              menuUrl: "/educationHome?t=ac_children",
              menuHide:
                this.$utils.getStore("lang", "LOCAL") === "en" ? true : false
            }
          ]
        },
        // {
        //   menuName: this.$t("menu.academic"),
        //   menuIcon: "",
        //   menuUrl: "",
        //   menuSubLink: [
        //     // {
        //     //   menuName: this.$t("menu.academic_institutions"),
        //     //   menuUrl: "/institutions"
        //     // },
        //     {
        //       menuName: this.$t("menu.academic_book"), //学术期刊
        //       menuUrl: "/magazine"
        //     },
        //     {
        //       menuName: this.$t("menu.academic_classroom"),
        //       menuUrl: "/classroom"
        //     }
        //   ]
        // },
        {
          menuName: this.$t("menu.science_technology"),
          menuIcon: "",
          menuUrl: "",
          menuSubLink: [
            {
              menuName: this.$t("menu.sci_workstation"),
              menuUrl: "/unitedStation"
            },
            {
              menuName: this.$t("menu.sci_achievements"),
              menuUrl: "/protection"
            },
            {
              menuName: this.$t("menu.sci_knowledge"),
              menuUrl: "/knowledge"
            }
          ]
        },
        {
          menuName: "博物馆之友",
          menuIcon: "",
          menuUrl: "",
          menuSubLink: [
            {
              menuName: "志愿者招募",
              menuUrl: "/volunteers?is=1"
            },
            {
              menuName: "志愿者风采",
              menuUrl: "/volunteers?is=2"
            },
            {
              menuName: "博物馆会员",
              menuUrl: "/volunteers?is=3"
            }
          ]
        }
      ],
      currentUrl: "", // 当前浏览器的url
      toggleName: "", // 菜单子项目名称
      config: {
        iconfont: "fzicon", // iconfont的字体
        icon_collapse: "menu_collapse", // 箭头----收缩
        icon_expand: "menu_expand" // 箭头------展开
      }
    };
  },
  created() {
    
    this.$i18n.locale = this.$utils.getStore("lang", "LOCAL") || "zh";
    // console.log(this.$i18n.locale);

    this.currentUrl = this.$route.fullPath;
    // console.log(this.currentUrl);
    //匹配当前页面路径，激活对应菜单项项
    this.$nextTick(() => {
      this.menulist.forEach((item, index) => {
        // 增加标记位,判断当前url然后自动展开或者激活对应项(刷新默认展开当前url的项)
        if (!item.menuSubLink && item.menuUrl) {
          //无子菜单
          // console.log(item.menuUrl)
          this.currentUrl === item.menuUrl
            ? this.$set(item, "defaultActive", true)
            : "";
        } else {
          //有子菜单
          if (item.menuSubLink) {
            item.menuSubLink.forEach((subitem, index) => {
              this.currentUrl === subitem.menuUrl
                ? this.$set(item, "defaultActive", true)
                : "";
            });
          }
        }
      });
    });
  },
  mounted() {
    // console.log(this.headTitle);
  },
  methods: {
    showModal(tabOptions, self) {
      tabOptions.forEach(item => {
        this[item] = false;
      });
      this[self] = !this[self];
      this.currentModal = self;
    },
    isToggle(name, defaultActive) {
      this.clearDefaultActive(); // 清除标记位,是否当前为默认展开
      defaultActive
        ? false
        : name !== this.toggleName
        ? (this.toggleName = name)
        : (this.toggleName = ""); // 判断展开收缩的核心
      // if (defaultActive) {
      //     return false;
      // } else if (name !== this.toggleName) {
      //     this.toggleName = name;
      // } else {
      //     this.toggleName = "";
      // }
    },
    clearDefaultActive() {
      this.menulist.forEach(item => {
        this.$delete(item, "defaultActive");
      });
    },
    toTarget(url, isParent) {
      var _self = this;
      if (isParent) _self.toggleName = "";
      _self.$router.push(url);
      _self[_self.currentModal] = false;
    },
    changeLanguage(lang) {
      var _self = this;
      _self.$utils.setStore("lang", lang, "LOCAL");
      _self.$router.push("/Index");
      _self.$route.name === "Index" && _self.reload();
      _self.$i18n.locale = lang;
      //原地刷新
      //   _self[_self.currentModal] = false;
    },
    toSearch() {
      var _self = this;
      var keywords = _self.searchKeyWords;
      if (keywords) {
        _self.$utils.setStore("keywords", keywords);
        _self.$router.push("/search");
      }
    }
  },
  computed: {},
  watch: {
    $route(val) {
     
      this.currentUrl = this.$route.fullPath; // 实时监测当前路由的变化并且赋值
      this.$i18n.locale = this.$utils.getStore("lang", "LOCAL") || "zh";
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../style/mixin.scss";
#topHeader {
  .header {
    @include wh(100%, 50px);
    @include fj();
    @include position(fixed);
    z-index: 2000;
    background-color: $bc;
    padding: 0 0.9375rem /* 15/16 */;
    box-sizing: border-box;
    .go-back {
      color: #edaa42;
      display: flex;
      align-items: center;
      img {
        @include wh(0.75rem /* 12/16 */, 1.25rem /* 20/16 */);
        margin-right: 10px;
        vertical-align: middle;
      }
    }
    // logo
    .logo-cont {
      width: 5rem /* 80/16 */;
      @include wh(6.25rem /* 100/16 */, 1.875rem /* 30/16 */);
      img {
        width: 100%;
      }
    }
    .btn-cont {
      width: 7.5rem /* 120/16 */;
      @include fj();
      .lang {
        position: relative;
        .lang-icon {
          @include wh(1.3125rem /* 21/16 */, 1.3125rem /* 21/16 */);
          // @include bgImg("../images/lang-app@2x.png");
          // &:before,
          // &:after {
          //   position: absolute;
          //   left: 0.375rem /* 6/16 */;
          //   content: "";
          //   @include wh(1.5625rem /* 25/16 */, 1.5625rem /* 25/16 */);
          //   transition: 0.15s ease;
          //   -webkit-transition: 0.15s ease;
          //   opacity: 0;
          // }
          // &:before {
          //   top: 0.375rem /* 6/16 */;
          //   border-top: 0.1875rem /* 3/16 */ solid #e4ac56;
          // }
          // &:after {
          //   top: -0.6875rem /* 11/16 */;
          //   border-bottom: 0.1875rem /* 3/16 */ solid #e4ac56;
          // }
          // &.lang-checked {
          //   border: 0;
          //   background: none;
          //   &:before {
          //     opacity: 1;
          //     // transform: rotate(135deg) translateX(5px)
          //     //     translateY(-25px);
          //     // -webkit-transform: rotate(135deg) translateX(5px)
          //     //     translateY(-25px);
          //     -webkit-transform: rotate(-45deg);
          //     -ms-transform: rotate(-45deg);
          //     transform: rotate(-45deg);
          //   }
          //   &:after {
          //     opacity: 1;
          //     -webkit-transform: rotate(45deg);
          //     -ms-transform: rotate(45deg);
          //     transform: rotate(45deg);
          //   }
          // }
        }
      }
      .search {
        position: relative;
        // 搜索按钮
        .search-icon {
          @include wh(1.3125rem /* 21/16 */, 1.3125rem /* 21/16 */);
          @include bgImg("../images/search-app@2x.png");
          &:before,
          &:after {
            position: absolute;
            left: 0.375rem /* 6/16 */;
            content: "";
            @include wh(1.5625rem /* 25/16 */, 1.5625rem /* 25/16 */);
            transition: 0.15s ease;
            -webkit-transition: 0.15s ease;
            opacity: 0;
          }
          &:before {
            top: 0.375rem /* 6/16 */;
            border-top: 0.1875rem /* 3/16 */ solid #e4ac56;
          }
          &:after {
            top: -0.6875rem /* 11/16 */;
            border-bottom: 0.1875rem /* 3/16 */ solid #e4ac56;
          }
          &.search-checked {
            border: 0;
            background: none;
            &:before {
              opacity: 1;
              // transform: rotate(135deg) translateX(5px)
              //     translateY(-25px);
              // -webkit-transform: rotate(135deg) translateX(5px)
              //     translateY(-25px);
              -webkit-transform: rotate(-45deg);
              -ms-transform: rotate(-45deg);
              transform: rotate(-45deg);
            }
            &:after {
              opacity: 1;
              -webkit-transform: rotate(45deg);
              -ms-transform: rotate(45deg);
              transform: rotate(45deg);
            }
          }
        }
      }
      .menu {
        position: relative;
        // width: 1.25rem /* 20/16 */;
        // height: 1.25rem /* 20/16 */;
        // 菜单按钮
        .menu-icon {
          // width: 1.25rem /* 20/16 */;
          // height: 0.125rem /* 2/16 */;
          // padding: 0.4375rem /* 7/16 */ 0;
          // border-top: 0.1875rem /* 3/16 */ solid #e4ac56;
          // border-bottom: 0.1875rem /* 3/16 */ solid #e4ac56;
          // background: #e4ac56;
          // background-clip: content-box;
          width: 1.25rem /* 20/16 */;
          height: 1.25rem /* 20/16 */;
          background: url("../images/menu@2x.png") no-repeat;
          background-size: 100% 100%;
          &:before,
          &:after {
            position: absolute;
            left: 0.375rem /* 6/16 */;
            content: "";
            width: 1.5625rem /* 25/16 */;
            height: 1.5625rem /* 25/16 */;
            transition: 0.155s ease;
            -webkit-transition: 0.15s ease;
            opacity: 0;
          }
          &:before {
            top: 0.375rem /* 6/16 */;
            border-top: 0.1875rem /* 3/16 */ solid #e4ac56;
          }
          &:after {
            top: -0.75rem /* 12/16 */;
            border-bottom: 0.1875rem /* 3/16 */ solid #e4ac56;
          }
          &.menu-checked {
            border: 0;
            background: none;
            &:before {
              opacity: 1;
              // transform: rotate(135deg) translateX(5px)
              //     translateY(-25px);
              // -webkit-transform: rotate(135deg) translateX(5px)
              //     translateY(-25px);
              -webkit-transform: rotate(-45deg);
              -ms-transform: rotate(-45deg);
              transform: rotate(-45deg);
            }
            &:after {
              opacity: 1;
              -webkit-transform: rotate(45deg);
              -ms-transform: rotate(45deg);
              transform: rotate(45deg);
            }
          }
        }
      }
    }
  }

  /*动画样式*/
  .modal-fade-enter-active {
    transition: all 0.3s;
    opacity: 1;
  }
  .modal-fade-enter {
    opacity: 0;
    -webkit-transform: scale3d(0.3, 0.3, 0.3);
    transform: scale3d(0.3, 0.3, 0.3);
  }
  .modal-fade-leave-active {
    transition: all 0.3s;
    opacity: 0;
  }
  .modal {
    position: fixed;
    top: 50px;
    bottom: 0;
    left: 0;
    right: 0;
    overflow-y: auto;
    width: 100%;
    z-index: 9999999;
    background-color: #002746;
    font-size: 1rem /* 16/16 */;
    .lang-modal {
      position: absolute;
      left: 50%;
      top: 40%;
      transform: translate(-50%, -50%);
      color: #bcbcbc;
      > p {
        @include wh(5rem /* 80/16 */, 2.5rem /* 40/16 */);
        line-height: 2.5rem /* 40/16 */;
        padding: 10px;
        img {
          width: 80%;
        }
      }
    }
    .search-modal {
      width: 90%;
      display: -webkit-flex;
      justify-content: space-between;
      align-items: center;
      margin: 9.375rem /* 150/16 */ auto;
      padding: 0.3125rem /* 5/16 */ 0.625rem /* 10/16 */;
      border-bottom: 0.0625rem /* 1/16 */ solid #e4ac56;
      color: #e4ac56;

      .search-left {
        display: -webkit-flex;
        justify-content: space-between;
        align-items: center;
        width: 17.5rem /* 280/16 */;
        .search-pic {
          display: inline-block;
          width: 1.3125rem /* 21/16 */;
          height: 1.3125rem /* 21/16 */;
          background: url("../images/search-app@2x.png") no-repeat;
          background-size: 100%;
        }
        input {
          border: none;
          outline: none;
          background-color: transparent;
          color: #d6d7d8;
          width: 100%;
          font-size: 0.875rem /* 14/16 */;
          height: 1.875rem /* 30/16 */;
          display: block;
          margin-left: 0.3125rem /* 5/16 */;
          &::-webkit-input-placeholder {
            color: #d6d7d8;
          }
        }
      }
    }
    .menu-modal {
      padding: 0.9375rem /* 15/16 */ 2.5rem /* 40/16 */;
      // 自定义过渡效果
      .sliderToggle-enter-active,
      .sliderToggle-leave-active {
        transition: all 0.3s linear;
        height: 100%;
        height: auto;
        overflow: hidden;
      }

      .sliderToggle-enter,
      .sliderToggle-leave-to {
        overflow: hidden;
        padding-top: 0;
        padding-bottom: 0;
        height: 0;
        opacity: 0;
      }

      // 侧边栏全局样式
      .sidebar-menu {
        white-space: nowrap;
        a {
          text-decoration: none;
          color: #8aa4af;
        }
        ul {
          white-space: nowrap;
          overflow: hidden;
        }
        // 首层li
        > li {
          position: relative;
          // 父菜单项
          > a {
            position: relative;
            padding: 0.9375rem /* 15/16 */ 0.3125rem /* 5/16 */ 0.9375rem
              /* 15/16 */ 1.1875rem /* 19/16 */;
            display: block;
            font-size: 1rem /* 16/16 */;
            // &:hover {
            //     color: #e4ac56;
            //     position: relative;
            //     &::before {
            //         content: "";
            //         display: block;
            //         position: absolute;
            //         left: 0;
            //         top: 50%;
            //         transform: translateY(-50%);
            //         width: 0.375rem /* 6/16 */;
            //         height: 0.375rem /* 6/16 */;
            //         background: #e4ac56;
            //     }
            // }
            .trangle {
              float: right;
              display: inline-block;
              width: 0.5rem /* 8/16 */;
              height: 0.5rem /* 8/16 */;
              -webkit-transform: rotate(45deg);
              -ms-transform: rotate(45deg);
              transform: rotate(45deg);
            }
            &.menu_expand {
              &::before {
                content: "";
                display: block;
                position: absolute;
                left: 0;
                top: 50%;
                transform: translateY(-50%);
                width: 0.375rem /* 6/16 */;
                height: 0.375rem /* 6/16 */;
                background: #e4ac56;
              }
              span {
                color: #e4ac56;
              }
              .trangle {
                //展开---向上
                border-left: 0.125rem /* 2/16 */ solid #e4ac56;
                border-top: 0.125rem /* 2/16 */ solid #e4ac56;
                margin-top: 0.5rem /* 8/16 */;
              }
            }
            &.menu_collapse {
              .trangle {
                // 收缩---向下
                border-right: 0.125rem /* 2/16 */ solid #8aa4af;
                border-bottom: 0.125rem /* 2/16 */ solid #8aa4af;
                margin-top: 0.25rem /* 4/16 */;
              }
            }
          }
          //子菜单
          > .tree-menu {
            > li {
              > a {
                padding: 0.9375rem /* 15/16 */ 0.625rem /* 10/16 */ 0.9375rem
                  /* 15/16 */ 2.5rem /* 40/16 */;
                display: block;
                font-size: 0.9375rem /* 15/16 */;
              }
              &.active {
                > a {
                  color: #e4ac56;
                }
              }
            }
          }
        }
      }

      // &.expand {
      //     width: 230px;
      // }

      // &.collapse {
      //     width: 3.125rem /* 50/16 */;
      //     .sidebar-menu {
      //         > li {
      //             > a {
      //                 padding: 0.9375rem /* 15/16 */ 0.3125rem /* 5/16 */
      //                     0.9375rem /* 15/16 */ 0.9375rem /* 15/16 */;
      //                 span,
      //                 i:last-child {
      //                     display: none;
      //                 }
      //             }
      //             .tree-menu {
      //                 display: none;
      //             }
      //             &:hover {
      //                 > a {
      //                     display: block;
      //                     span {
      //                         display: block;
      //                         position: absolute;
      //                         left: 2.9375rem /* 47/16 */;
      //                         width: 9.5625rem /* 153/16 */;
      //                         padding: 0.9375rem /* 15/16 */ 0.3125rem
      //                             /* 5/16 */ 0.9375rem /* 15/16 */
      //                             1.1875rem /* 19/16 */;
      //                         background-color: #222d32;
      //                         color: #fff;
      //                         width: 11.0625rem /* 177/16 */;
      //                         top: 0;
      //                         border-radius: 0 0.3125rem /* 5/16 */ 0 0;
      //                     }
      //                     i:last-child {
      //                         display: inline-block;
      //                         position: absolute;
      //                         right: -10.3125rem /* 165/16 */;
      //                         top: 50%;
      //                         transform: translateY(-50%);
      //                         color: #fff;
      //                     }
      //                 }
      //                 > .tree-menu {
      //                     display: block;
      //                     position: absolute;
      //                     left: 2.9375rem /* 47/16 */;
      //                     width: 11.25rem /* 180/16 */;
      //                     background-color: #222d32;
      //                     color: #fff;
      //                     top: 2.875rem /* 46/16 */;
      //                     width: 11.25rem /* 180/16 */;
      //                     border-radius: 0 0 0.3125rem /* 5/16 */
      //                         0.3125rem /* 5/16 */;
      //                 }
      //             }
      //         }
      //     }
      // }
    }
  }
}
</style>
